import PropTypes from 'prop-types';
export default function PatagoniaAddCategory({
  children
}) {
  return children;
}
PatagoniaAddCategory.propTypes = {
  children: PropTypes.node.isRequired,
  name: PropTypes.string.isRequired
};